import { availabilityClearPromoCode } from '@actions/availability.action';
import { inject } from '@angular/core';
import { HIDDEN_PROMO_CODES_LIST } from '@constants/app.constants';
import { GrowthBookFeatureKeys } from '@models/growthbook.models';
import { Store } from '@ngrx/store';
import { selectSearchInputState } from '@selectors/availability.selector';
import { GrowthBookService } from '@services/growthbook/growthbook.service';
import { combineLatest, take, map, catchError, of, Observable } from 'rxjs';

export const clearPromoCodeSerchGuard = (): Observable<boolean>  => {
  const store = inject(Store);
  const gbs = inject(GrowthBookService);
  const gbf = GrowthBookFeatureKeys;
  const hiddenPromoCodesList = HIDDEN_PROMO_CODES_LIST;
  const isPromoOnRoundTripEnabled: boolean =
    gbs.growthBook.isOn(gbf.FEAT_US902_PROMO_CODE_ON_ROUND_TRIP) &&
    (
      gbs.growthBook.getFeatureValue(gbf.FEAT_US902_PROMO_CODE_ON_ROUND_TRIP, '') === 'b' ||
      gbs.growthBook.getFeatureValue(gbf.FEAT_US902_PROMO_CODE_ON_ROUND_TRIP, '') === 'c' ||
      gbs.growthBook.getFeatureValue(gbf.FEAT_US902_PROMO_CODE_ON_ROUND_TRIP, '') === 'd' ||
      gbs.growthBook.getFeatureValue(gbf.FEAT_US902_PROMO_CODE_ON_ROUND_TRIP, '') === 'e' 
    );

  return combineLatest([
    store.select(selectSearchInputState),
  ]).pipe(
    take(1),
    map(([search]) => {
      if (
        search?.promotionCode &&
        isPromoOnRoundTripEnabled &&
        hiddenPromoCodesList.includes(search?.promotionCode)
      ) {
        store.dispatch(availabilityClearPromoCode());
      }
      return true;
    }),
    catchError((error) => {
      console.error(error);
      return of(true);
    }),
  );
};
